// extracted by mini-css-extract-plugin
module.exports = {"title":"NavigationDrawer_title_2dW0h","close":"NavigationDrawer_close_3LVzP","container":"NavigationDrawer_container_3HUHS"};